// FIXME: 暫定対応 - endTimeがstringで渡ってくるので、Numberに変換する処理
export function validateFormData(data: any) {
    const _endTime = data.endTime;
    return {
        ...data,
        endTime: Number(_endTime),
    };
}

